import _ from 'lodash'

export const PRIVILEGES = {
	MOCK_ALWAYS_DEINED: 'asd,kjh12p98eupaljknfd1973hlasijndp89',
	ORDER_ADD: 'order.add',
	ORDER_VIEW: 'order.view',
	SEE_PRICES: 'price.view',
	PROJECT_ADD: 'project.add',
	PROJECT_VIEW: 'project.view',
	PROJECT_COMPANY_VIEW: 'project.view.company',
	PROJECT_ASSIGNED_COMPANY_VIEW: 'project.view.assigned.company',
	PROJECT_EDIT: 'project.edit',
	PROJECT_DOWNLOADS: 'project.download',
	PROJECT_CLONE: 'project.clone',
	PROJECT_DELETE: 'project.delete',
	PROJECT_REGISTRATION: 'project.registration',
	PROJECT_ASSIGN_THIRD_PARTY: 'project.asigment.thirdparty',
	PRODUCT_ADD_REFERENCE: 'product.add.reference',
	SUPPORT_REQUEST: 'support.request',
	BUDGET_PRICING: 'budget',
	BUDGET_REQUEST: 'budget.request',
	BUDGET_ADD: 'budget.add',
	DOWNLOADS_VIEW: 'downloads.view',
	BACKOFFICE_VIEW: 'backoffice',
	COMPANY_MANAGE_USER: 'company.manage.user'
}

export const PRIVILEGES_NAMES = _.invert(PRIVILEGES)
